import { RARITY_LABELS, RARITY_COLORS } from '../../data/spells';
import { MagicSpellCard } from '../atoms/MagicSpellCard';

/**
 * MagicSelectOverlay — shown when a magic tier milestone is reached (every 2 tiers).
 *
 * New spell mode:  presents 3 rarity-weighted choices; player picks one to add.
 * Upgrade mode:    presents up to 3 already-owned spells; player picks one to level up.
 *
 * Props:
 *   spells     — array of spell objects (new) or spell objects with .upgradeLevel (upgrade)
 *   isUpgrade  — true when offering upgrades instead of new spells
 *   onChoose   — (spellId, isUpgrade) → void
 */
export function MagicSelectOverlay({ spells, isUpgrade, onChoose }) {
  return (
    <div className="magic-select-overlay">
      <h2 className="magic-select-title">
        {isUpgrade ? '⬆️ Spell Upgrade' : '✨ Magic Unlocked'}
      </h2>
      <p className="magic-select-sub">
        {isUpgrade
          ? 'Choose a spell to upgrade'
          : 'Choose a spell to add to your arsenal'}
      </p>

      <div className="magic-select-choices">
        {spells.map(spell => {
          const rarityColor = RARITY_COLORS[spell.rarity] ?? '#9e9e9e';
          const rarityLabel = RARITY_LABELS[spell.rarity] ?? spell.rarity;
          const upgradeDesc = isUpgrade && spell.upgrades
            ? spell.upgrades.find(u => u.level === spell.upgradeLevel)?.desc
            : null;

          return (
            <MagicSpellCard
              key={spell.id}
              spell={spell}
              rarityLabel={isUpgrade ? `⬆ Level ${spell.upgradeLevel}` : rarityLabel}
              rarityColor={rarityColor}
              desc={upgradeDesc}
              onClick={() => onChoose(spell.id, isUpgrade)}
            />
          );
        })}
      </div>
    </div>
  );
}
